import { DateTime } from 'luxon'

import type { Post } from '../model/contracts'

export interface DayGroup {
  dateKey: string
  dateTime: DateTime
  count: number
  posts: Post[]
}

export function groupPostsByDay(posts: Post[]): DayGroup[] {
  const map = new Map<string, DayGroup>()
  const order: string[] = []

  for (const post of posts) {
    const dt = DateTime.fromISO(post.timestamp).startOf('day')
    const key = dt.toFormat('yyyy-MM-dd')

    if (!map.has(key)) {
      map.set(key, { dateKey: key, dateTime: dt, count: 0, posts: [] })
      order.push(key)
    }

    const group = map.get(key)!
    group.posts.push(post)
    group.count++
  }

  return order.map((k) => map.get(k)!)
}
